import React from 'react';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import {theme} from '../../../../styles';
import GaiaIcon from '../../../../icons/GaiaIcon';

export default function ControlsExplained({
    setStepCount,
}: {
    setStepCount: SetState<number>;
}) {
    return (
        <div>
            <Typography variant='h5' style={{marginTop: theme.spacing(2)}}>
                More Planning Tools
            </Typography>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'left',
                    marginTop: theme.spacing(2),
                }}
            >
                <GaiaIcon
                    name='waypoint'
                    style={{
                        position: 'relative',
                        top: 8,
                        width: 24,
                        height: 24,
                    }}
                />
                <Typography
                    variant='h6'
                    style={{fontWeight: 'normal', margin: theme.spacing(1)}}
                >
                    Create a waypoint
                </Typography>
            </div>
            <Typography
                variant='body1'
                style={{marginLeft: theme.spacing(4), textAlign: 'left'}}
            >
                Mark points of interest, campsites, important locations, or
                views to remember on the map.
            </Typography>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'left',
                    marginTop: theme.spacing(2),
                }}
            >
                <GaiaIcon
                    name='route'
                    style={{
                        position: 'relative',
                        top: 8,
                        width: 24,
                        height: 24,
                    }}
                />
                <Typography
                    variant='h6'
                    style={{fontWeight: 'normal', margin: theme.spacing(1)}}
                >
                    Create a route
                </Typography>
            </div>
            <Typography
                variant='body1'
                style={{marginLeft: theme.spacing(4), textAlign: 'left'}}
            >
                Used to plan trips, measure distance and elevation.
            </Typography>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'left',
                    marginTop: theme.spacing(2),
                }}
            >
                <GaiaIcon
                    name='area'
                    style={{
                        position: 'relative',
                        top: 8,
                        width: 24,
                        height: 24,
                    }}
                />
                <Typography
                    variant='h6'
                    style={{fontWeight: 'normal', margin: theme.spacing(1)}}
                >
                    Create an area
                </Typography>
            </div>
            <Typography
                variant='body1'
                style={{marginLeft: theme.spacing(4), textAlign: 'left'}}
            >
                Measure the perimeter and acreage/km<sup>2</sup> of a location.
            </Typography>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    marginTop: theme.spacing(2),
                }}
            >
                <Button
                    style={{fontSize: 14}}
                    onClick={() =>
                        setStepCount((prevState: number) => prevState - 1)
                    }
                >
                    Back
                </Button>
                <Button
                    color='primary'
                    variant='contained'
                    style={{fontSize: 14}}
                    onClick={() =>
                        setStepCount((prevState: number) => prevState + 1)
                    }
                >
                    Next
                </Button>
            </div>
        </div>
    );
}
